import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import GradebookSyncDashboard from "./routes/GradebookSyncDashboard";
import GradingPeriodMapping from "./routes/GradingPeriodMapping";
import ClassSubjectMapping from "./routes/ClassSubjectMapping";
import ReportSubjectMapping from "./routes/ReportSubjectMapping";
import GradebookColumnMapping from "./routes/GradebookColumnMapping";


export default store => ({
  path: ":curriculum_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-gradebooksync" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    GradebookSyncDashboard(store),
    GradingPeriodMapping(store),
    ClassSubjectMapping(store),
    ReportSubjectMapping(store),
    GradebookColumnMapping(store),
  ],
});
